import * as Context from "effect/Context";
import type * as Stream from "effect/Stream";

import type { PrimaryConnectionRegistration } from "../connection/catalog.ts";

export class PlatformConnectionSource extends Context.Service<
  PlatformConnectionSource,
  {
    // Each emission is the environment as currently discovered, or none while it
    // cannot be. The registry reconciles to it, so re-emitting can add or remove it.
    readonly registrations: Stream.Stream<ReadonlyArray<PrimaryConnectionRegistration>>;
  }
>()("@heydex/client-runtime/platform/source/PlatformConnectionSource") {}
